import { Component, AfterViewInit, Inject } from '@angular/core';
import { PatientProfileService } from "../Service/PatientProfile.Service";
import { UserProfileModel, UserData } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
declare var require: any;

@Component({
    selector: 'MentisSoft-PatientProfile',
    template: require('../Template/PatientProfile.template.html'),
    styles: [require('../Template/PatientProfile.css')]
})

export class PatientProfileComponent implements AfterViewInit {

    constructor(private router: Router, @Inject(SecurityService) private _SecurityService: SecurityService, private _PatientProfileService: PatientProfileService, private _titleService: Title) {

    };
    MobileNoValid = false;
    UpdateStatusMessage = null;
    InValidEmail = false;
    isMobileEdit = false;
    isEmailEdit = false;
    isEditedSuccess = false;
    loading = false;

    userprofile: UserProfileModel = new UserProfileModel();
    editprofile: UserProfileModel = new UserProfileModel();

    userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);


    ngAfterViewInit(): void {
        $('#overlay').hide();
        this._titleService.setTitle("PatientProfile Reports");
        this.getPatientProfileReports();
    }

    getPatientProfileReports() {
        this.loading = true;
        this.userData.pid = this._SecurityService.pid;
        this._PatientProfileService.GetLoggedInUserProfile(this.userData.User, this.userData.Authentication, this.userData.pid, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {

                if (p != null && p.ValidUser && p.SessionTimeout != "Session Expired") {
                    this._SecurityService.errorMessage = "";
                    this.loading = false;

                    this.userprofile.age = p.age;
                    this.userprofile.dob = p.dob;
                    this.userprofile.Email = p.Email;
                    this.userprofile.mobile = p.mobile;
                    this.userprofile.PatientID = p.PatientID;
                    this.userprofile.RegistrationDate = p.RegistrationDate;
                    this.userprofile.SponsorCode = p.SponsorCode;
                    this.userprofile.UserName = p.UserName;
                    this.userprofile.Sex = p.Sex;
                    this.userprofile.ImageByte = p.ImageByte;
                    this.editprofile.Email = p.Email;
                    this.editprofile.mobile = p.mobile;
                }

                else if (p == null || p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            }

            );
    }



    ValidateForm() {
        if (this.editprofile.mobile.length < 8)
            this.MobileNoValid = true;
        else
            this.MobileNoValid = false;
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var result = re.test(String(this.editprofile.Email).toLowerCase());
        if (result == false) {
            this.InValidEmail = true;
        }
        else {
            this.InValidEmail = false;
        }
        if (!this.InValidEmail && !this.MobileNoValid) {
            this._PatientProfileService.SaveDetails(this._SecurityService.pid, this.editprofile.Email, this.editprofile.mobile, this.userData.Authentication, this.userData.User)
                .subscribe(
                data => {
                    if (data === 1 || data.sessiontimeout != "session expired") {
                        this.UpdateStatusMessage = "Data Updated Successfully";
                        this.isEmailEdit = false;
                        this.isMobileEdit = false;
                        this.isEditedSuccess = false;
                        this.userprofile.Email = this.editprofile.Email;
                        this.userprofile.mobile = this.editprofile.mobile;
                    }
                    else if (data == null || data.sessiontimeout == "session expired") {
                        this._SecurityService.errorMessage = "your session has expired. please login again.";
                        this.router.navigate(["/login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("error while validating...");
                }

                );
        }

    }

    keyPress(event: any) {

        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    resetEditedData(isMobileEmail: boolean) {
        this.editprofile.mobile = this.userprofile.mobile;
        this.editprofile.Email = this.userprofile.Email;
        if (isMobileEmail) {
            this.isEmailEdit = false;
            this.InValidEmail = false
        }
        else {
            this.isMobileEdit = false;
            this.MobileNoValid = false;
        }

    }







}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/PatientProfile/Component/PatientProfile.Component.ts